const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('.carousel').forEach((el) => {
	let dragging = false;
	let moving   = false;

	const syncSettled = () => {
		el.classList.toggle('is-settled', !dragging && !moving);
	};

	new Swiper(el, {
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 0,
		loop: true,
		loopAdditionalSlides: 2,
		speed: prefersReduce.matches ? 1 : 600,
		grabCursor: true,
		slideToClickedSlide: true,
		threshold: 5,
		touchAngle: 30,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		slideActiveClass: 'is-active',
		navigation: {
			prevEl: el.querySelector('.carousel_prev'),
			nextEl: el.querySelector('.carousel_next'),
		},
		keyboard: { enabled: true, onlyInViewport: true },
		a11y: {
			prevSlideMessage: '前のスライド',
			nextSlideMessage: '次のスライド',
		},
		on: {
			afterInit() { syncSettled(); },
			transitionStart() { moving = true;  syncSettled(); },
			transitionEnd()   { moving = false; syncSettled(); },
			touchStart()      { dragging = true; syncSettled(); },
			touchEnd()        { dragging = false; requestAnimationFrame(syncSettled); },
		},
	});
});


document.addEventListener('DOMContentLoaded', function () {
  var appearanceBuffer = 60;
  var ticking = false;

  function applyDelay(el) {
    var index = el.dataset.delay;
    if (index !== undefined && index !== '') {
      el.style.setProperty('--fade-index', String(index));
    }
  }

  // --- 起動時フェードイン ---
  function initLoadFade() {
    var targets = document.querySelectorAll('.fade-load:not(.active)');
    targets.forEach(applyDelay);

    // 初期スタイルを適用してからクラスを付与し、トランジションを確実に発火させる
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        targets.forEach(function (el) {
          el.classList.add('active');
        });
      });
    });
  }

  // --- スクロール連動フェードイン ---
  function checkFade() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var windowBottom = scrollTop + window.innerHeight - appearanceBuffer;

    document.body.classList.toggle('scrolled-down', scrollTop > 0);

    document.querySelectorAll('.fade:not(.active)').forEach(function (el) {
      var offset = el.getBoundingClientRect().top + scrollTop;
      var height = el.offsetHeight;
      if (offset + height >= scrollTop && offset <= windowBottom) {
        applyDelay(el);
        el.classList.add('active');
      }
    });
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      checkFade();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  initLoadFade();

  checkFade();
});